<dashboard-dialog-frame class="goal-editor-dialog" [header]="addOrEditTitle()" [dialogRef]="dialogRef">

	<div class="p-2 h-100 d-flex flex-column justify-content-between">
		<div class="d-flex flex-column gap-2">
			<common-select-field [field]="form.ventureId()"></common-select-field>
			<common-select-field [field]="form.status()"></common-select-field>
			<common-select-field [field]="form.categoryId()"></common-select-field>
			<common-text-field [field]="form.summary()"></common-text-field>
			<common-text-field [field]="form.details()"></common-text-field>
		</div>

		<div class="mt-3">
			<common-button-row [center]="true">
				<button class="btn btn-primary" #goalEditorBtn>{{buttonText()}}</button>
				<button class="btn btn-standard" (click)="revertChanges()">Revert</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Cancel</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>